import React, { Fragment } from 'react'
import Button from './../../../../modules/Button'
import injectStyles from 'react-jss'
import { Link } from 'react-router-dom'

const styles = {
  logout: {
    color: '#fd4a1a',
    background: '-webkit-linear-gradient(left, #fa8e2b, #fd4a1a)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
  },
  avatar: {
    width: 50,
    height: 50,
    position: 'absolute',
    top: 10,
    left: 10,
    borderRadius: 3,
  },
}

const WelcomeBack = ({ classes, name, avatarUrl, logout }) => <Fragment>
  <h2>Welcome back, {name}</h2>
  <br /><br /><br />
  <Link to="/select-repository">
    <Button>
      <img className={classes.avatar} src={avatarUrl} />
      <span>Continue as {name}</span>

    </Button>
  </Link>
  <br /><br /><br />
  <a
    href="javascript:;"
    onClick={logout}
    className={classes.logout}
  >
    Logout
  </a>
</Fragment>

export default injectStyles(styles)(WelcomeBack)



// WEBPACK FOOTER //
// ./src/pages/Login/LoginContinue/WelcomeBack/WelcomeBack.js